/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExamQuestion } from './examQuestion';

/**
 * Pool of generated oral exam questions
 */
export interface AssessmentResponse {
  questionPool: ExamQuestion[];
}
